import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "relative" };
var _hoisted_2 = ["type", "id", "required", "novalidate", "placeholder", "value"];
var _hoisted_3 = ["for"];
var _hoisted_4 = {
    key: 1,
    class: "ml-6 mt-1 text-feed-red text-12px font-bold"
};
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-eye_close text-24px text-grey-95" }, null, -1);
var _hoisted_6 = [
    _hoisted_5
];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-eye text-24px text-grey-95" }, null, -1);
var _hoisted_8 = [
    _hoisted_7
];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'inputPassword',
    props: {
        value: { type: String, required: true },
        required: { type: Boolean, required: false, default: false },
        validate: { type: Boolean, required: false, default: true },
        isCurrentPassword: { type: Boolean, required: false, default: false },
        label: { type: String, required: false, default: '' },
        placeholder: { type: String, required: false, default: '' },
        id: { type: String, required: false, default: '' },
    },
    emits: [
        'updateValue',
        'checkTextLength',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var visible = ref(false);
        var errorMessage = ref('');
        var inputValue = ref(props.value);
        var inputShow = function () {
            visible.value = true;
        };
        var inputHide = function () {
            visible.value = false;
        };
        var validatePassword = function (v) {
            return /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9!-/:-@¥[-`{-~]{8,}$/.test(v);
        };
        var updateValue = function (v) {
            errorMessage.value = '';
            if (!validatePassword(v) && !props.isCurrentPassword) {
                errorMessage.value = "8\u6587\u5B57\u4EE5\u4E0A\u306E\u534A\u89D2\u82F1\u6570\u5B57\u8A18\u53F7\uFF08\u5927\u6587\u5B57\u3001\u6570\u5B57\u3092\u305D\u308C\u305E\u308C1\u6587\u5B57\u4EE5\u4E0A\u542B\u3080\uFF09\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
            }
            emit('updateValue', { value: v, isValid: !errorMessage.value });
        };
        var checkTextLength = function (v) {
            errorMessage.value = '';
            if (!validatePassword(v) && !props.isCurrentPassword) {
                errorMessage.value = "8\u6587\u5B57\u4EE5\u4E0A\u306E\u534A\u89D2\u82F1\u6570\u5B57\u8A18\u53F7\uFF08\u5927\u6587\u5B57\u3001\u6570\u5B57\u3092\u305D\u308C\u305E\u308C1\u6587\u5B57\u4EE5\u4E0A\u542B\u3080\uFF09\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
            }
            else if (props.isCurrentPassword && v.trim().length == 0) {
                errorMessage.value = "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
            }
            emit('checkTextLength', { value: v, isValid: !errorMessage.value });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    name: "password",
                    type: visible.value ? 'text' : 'password',
                    id: __props.id,
                    class: _normalizeClass(["floating-label p-6 pr-12 w-full text-16px leading-none border border-grey-95 rounded", [!__props.value ? '' : 'value']]),
                    required: __props.required,
                    novalidate: __props.validate,
                    placeholder: __props.placeholder,
                    value: __props.value,
                    onInput: _cache[0] || (_cache[0] = function ($event) { return (updateValue($event.target.value)); }),
                    onBlur: _cache[1] || (_cache[1] = function ($event) { return (checkTextLength($event.target.value)); })
                }, null, 42, _hoisted_2),
                (__props.label)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        for: __props.id,
                        class: "px-2"
                    }, [
                        _createElementVNode("span", null, _toDisplayString(__props.label), 1)
                    ], 8, _hoisted_3))
                    : _createCommentVNode("", true),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true),
                (visible.value == false)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "absolute right-5 top-6",
                        onClick: inputShow
                    }, _hoisted_6))
                    : _createCommentVNode("", true),
                (visible.value == true)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        class: "absolute right-5 top-6",
                        onClick: inputHide
                    }, _hoisted_8))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
